import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@cumlaude/shared-authentication';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserAuthenticationService } from '../../services/user-authentication.service';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-new-session',
	templateUrl: './new-session.component.html',
	styleUrls: ['./new-session.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewSessionComponent implements OnInit {
	private readonly authService = inject(AuthService);
	private readonly oAuthService = inject(OAuthService);
	private readonly userAuthenticationService = inject(UserAuthenticationService);
	private readonly activatedRoute = inject(ActivatedRoute);

	ngOnInit() {
		const msg = this.activatedRoute.snapshot.queryParamMap.get('toastr');
		this.authService.clearSessionStorage();
		this.userAuthenticationService.clearSessionStorage();
		this.oAuthService.initCodeFlow(msg ?? undefined);
	}
}
